module.exports = __webpack_public_path__ + "static/media/triviatime.fdbb1280.png";